import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

import AOS from 'aos'
import 'aos/dist/aos.css'

createApp(App).use(store).use(router).mount('#app')

AOS.init({
  duration: 800,
  easing: 'ease-in-out' 
})